module.exports = __webpack_public_path__ + "img/selected4-min.ed3c7c62.png";